import React from "react";
import { ArrowRight, Building2, Handshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheMovement() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll();
  return <section id="join-the-movement" className="dark bg-background text-foreground w-full font-sans">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {}
        <div ref={leftRef} className={`relative bg-white text-[hsl(217,64%,11%)] flex flex-col justify-center items-start p-10 md:p-16 lg:p-24 overflow-hidden transition-opacity duration-700 ${leftVisible ? "opacity-100" : "opacity-0"}`}>
          {}
          <span className="absolute right-[-20px] bottom-[-40px] lg:right-10 lg:bottom-0 text-[180px] md:text-[240px] font-bold leading-none opacity-[0.04] select-none font-serif pointer-events-none">
            01
          </span>

          <div className="relative z-10 max-w-xl">
            <div className="flex items-center gap-3 mb-6 text-[hsl(217,64%,11%)]/80">
              <Building2 className="w-6 h-6" />
              <span className="text-sm font-bold tracking-widest uppercase">
                Entrepreneurs.
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.1]">
              For Small Business & Entrepreneurs
            </h2>

            <p className="text-lg md:text-xl text-[hsl(217,64%,11%)]/70 mb-10 max-w-md leading-relaxed">
              Access capital, expert resources, and advocacy to grow your
              enterprise. Join a network of 120,000+ Hispanic-owned businesses
              driving Colorado's economy.
            </p>

            <Button asChild size="lg" className="bg-[hsl(217,64%,11%)] text-white hover:bg-[hsl(217,64%,11%)]/90 border-none shadow-xl h-14 px-8 text-lg rounded-sm">
              <Link to="/JoinUsPage">
                Join Now <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative bg-[hsl(217,64%,11%)] text-white flex flex-col justify-center items-start p-10 md:p-16 lg:p-24 overflow-hidden transition-opacity duration-700 delay-200 ${rightVisible ? "opacity-100" : "opacity-0"}`}>
          {}
          <span className="absolute right-[-20px] bottom-[-40px] lg:right-10 lg:bottom-0 text-[180px] md:text-[240px] font-bold leading-none opacity-[0.04] select-none font-serif pointer-events-none text-white">
            02
          </span>

          <div className="relative z-10 max-w-xl">
            <div className="flex items-center gap-3 mb-6 text-[hsl(38,92%,55%)]">
              <Handshake className="w-6 h-6" />
              <span className="text-sm font-bold tracking-widest uppercase">
                Corporate Partners
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.1]">
              For Corporations & Partners
            </h2>

            <p className="text-lg md:text-xl text-white/70 mb-10 max-w-md leading-relaxed">
              Drive economic impact and diversity through strategic alliance.
              Partner with COHCC to reach the 8th largest Hispanic market in the
              U.S.
            </p>

            <Button asChild variant="secondary" size="lg" className="bg-[hsl(38,92%,55%)] text-[hsl(217,64%,11%)] hover:bg-[hsl(38,92%,55%)]/90 border-none shadow-xl h-14 px-8 text-lg rounded-sm font-semibold">
              <Link to="/JoinUsPage">
                Partner With Us <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}